import React from 'react';
import { IntlShape } from 'react-intl';
import { SVGS } from '../../../../assets/images';
import PopupMenuActions from '../../../../components/shared/popup-menu';
import { PopupMenuAction } from '../../../../components/shared/popup-menu/types';
import { Lx } from '../../../../i18n/consts';

interface Props {
    intl: IntlShape;
    onAddNewCostClick?: () => void;
    onEditCostClick?: () => void;
    onDeleteCostClick?: () => void;
}

const CostActionMenu: React.FC<Props> = (props) => {
    const { intl } = props;
    const actions: PopupMenuAction[] = [];

    if (props.onAddNewCostClick) {
        actions.push({
            name: intl.formatMessage({id: Lx.Cost.ADD}),
            icon: <SVGS.PlusIcon/>,
            callback: props.onAddNewCostClick
        })
    }

    if (props.onEditCostClick) {
        actions.push({
            name: intl.formatMessage({ id: Lx.Cost.EDIT }),
            icon: <SVGS.EditIcon />,
            callback: props.onEditCostClick
        })
    }

    if (props.onDeleteCostClick) {
        actions.push({
            name: intl.formatMessage({ id: Lx.Cost.DELETE }),
            icon: <SVGS.DeleteIcon />,
            callback: props.onDeleteCostClick
        })
    }

    return(<PopupMenuActions actionIcon={<SVGS.ActionIcon />} actions={actions} newGen size={'small'} />)
}

export default CostActionMenu
